import { render } from "./ProductsPriceHistory.vue?vue&type=template&id=a68df30e"
import script from "./ProductsPriceHistory.vue?vue&type=script&lang=js"
export * from "./ProductsPriceHistory.vue?vue&type=script&lang=js"

import "./ProductsPriceHistory.vue?vue&type=style&index=0&id=a68df30e&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__